import { defineMessages } from 'react-intl';

export default defineMessages({
  topLine: {
    id: 'booking.payment.disclaimer.top',
    defaultMessage:
      'By confirming this booking you agree to the {termsLink} and {policyLink}. ' +
      'We only charge your card when the provider has accepted the booking.',
  },
  bottomLine: {
    id: 'booking.payment.disclaimer.bottom',
    defaultMessage: 'Winnow is secure and your details are protected.',
  },
  termsLinkLabel: {
    id: 'booking.payment.disclaimer.terms',
    defaultMessage: 'Terms & Conditions',
  },
  policyLinkLabel: {
    id: 'booking.payment.disclaimer.policy',
    defaultMessage: 'Cancelation Policy',
  },
});
